import { render, staticRenderFns } from "./TaskTypes.vue?vue&type=template&id=6dfabf52"
import script from "./TaskTypes.vue?vue&type=script&lang=ts"
export * from "./TaskTypes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports